 <button
  (click)="toggle()"
  [class.label-aligned]="alignment() === 'label'"
  class="description-button"
  mat-icon-button
  type="button"
>
  <ui-icon faName="circle-question" faStyle="light"></ui-icon>
</button>
